import React, { useEffect, useState } from "react";
import { Loader2, AlertOctagon, Terminal } from "lucide-react";
import api from "../../services/api";

const severityColor = {
  critical:
    "bg-red-500/10 text-red-400 border-red-500/30 shadow-[0_0_8px_rgba(239,68,68,0.2)]",
  high: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  medium: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  low: "bg-sky-500/10 text-sky-400 border-sky-500/30",
};

const statusColor = {
  open: "bg-red-500/10 text-red-400 border-red-500/30",
  investigating: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  resolved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  closed: "bg-gray-500/10 text-gray-400 border-gray-500/30",
};

const IncidentResponse = () => {
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getIncidents().then((r) => {
      setIncidents(r.incidents || []);
      setLoading(false);
    });
  }, []);

  if (loading)
    return (
      <div className="min-h-screen bg-[#0C0E12] flex items-center justify-center">
        <Loader2 className="animate-spin text-cyan-400" size={40} />
      </div>
    );

  return (
    <div
      className="min-h-screen bg-[#0C0E12] text-gray-300 p-8"
      style={{
        backgroundImage:
          "radial-gradient(circle at 10% 0%, rgba(239,68,68,0.06), transparent 40%), radial-gradient(circle at 90% 100%, rgba(6,182,212,0.05), transparent 40%)",
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-2 mb-2">
          <AlertOctagon size={14} className="text-red-400" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-red-400 font-mono">
            Active Incidents
          </span>
        </div>
        <h1 className="text-3xl font-bold text-white mb-1">
          Incident <span className="text-red-400">Response</span>
        </h1>
        <p className="text-gray-500 text-sm mb-6">
          Security ticket tracking and triage console.
        </p>

        <div className="bg-[#12151C] rounded-xl border border-white/5 overflow-hidden shadow-[0_0_30px_rgba(0,0,0,0.5)]">
          <div className="flex items-center gap-2 px-6 py-3 bg-black/40 border-b border-white/5">
            <Terminal size={12} className="text-cyan-400" />
            <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-gray-500">
              incidents.log — {incidents.length} record
              {incidents.length !== 1 ? "s" : ""}
            </span>
          </div>
          <table className="w-full">
            <thead className="bg-black/20">
              <tr className="text-left text-[10px] font-mono tracking-[0.2em] uppercase text-gray-500">
                <th className="px-6 py-3.5">Ticket</th>
                <th className="px-6 py-3.5">Title</th>
                <th className="px-6 py-3.5">Severity</th>
                <th className="px-6 py-3.5">Status</th>
                <th className="px-6 py-3.5">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {incidents.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-6 py-12 text-center">
                    <div className="text-emerald-400 font-mono text-sm flex items-center justify-center gap-2">
                      <span className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)]" />
                      All clear — no active incidents
                    </div>
                  </td>
                </tr>
              ) : (
                incidents.map((i) => (
                  <tr
                    key={i.id}
                    className="hover:bg-cyan-500/5 transition-colors"
                  >
                    <td className="px-6 py-4 font-mono text-xs text-cyan-300">
                      {i.ticketNumber}
                    </td>
                    <td className="px-6 py-4 font-medium text-white text-sm">
                      {i.title}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex px-2.5 py-1 text-[10px] font-mono uppercase tracking-wider rounded-md border ${severityColor[i.severity] || "bg-gray-500/10 text-gray-400 border-gray-500/30"}`}
                      >
                        {i.severity}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex px-2.5 py-1 text-[10px] font-mono uppercase tracking-wider rounded-md border ${statusColor[i.status] || "bg-gray-500/10 text-gray-400 border-gray-500/30"}`}
                      >
                        {i.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-xs text-gray-500 font-mono">
                      {new Date(i.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default IncidentResponse;
